/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Invite_TitleInputs */

const en_team_invite_title = /** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite Staff Member`)
};

const es_team_invite_title = /** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitar Miembro del Personal`)
};

const fr_team_invite_title = /** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviter un membre du personnel`)
};

const de_team_invite_title = /** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teammitglied einladen`)
};

const id_team_invite_title = /** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undang Anggota Staf`)
};

/** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */
const ja_team_invite_title = en_team_invite_title;

/** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */
const zh_team_invite_title = en_team_invite_title;

/** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */
const ar_team_invite_title = en_team_invite_title;

/** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */
const it_team_invite_title = en_team_invite_title;

/** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */
const ru_team_invite_title = en_team_invite_title;

/** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */
const pt_team_invite_title = en_team_invite_title;

/** @type {(inputs: Team_Invite_TitleInputs) => LocalizedString} */
const ko_team_invite_title = en_team_invite_title;

/**
* | output |
* | --- |
* | "Invite Staff Member" |
*
* @param {Team_Invite_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_invite_title = /** @type {((inputs?: Team_Invite_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Invite_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_invite_title(inputs)
	if (locale === "es") return es_team_invite_title(inputs)
	if (locale === "fr") return fr_team_invite_title(inputs)
	if (locale === "de") return de_team_invite_title(inputs)
	if (locale === "ja") return ja_team_invite_title(inputs)
	if (locale === "zh") return zh_team_invite_title(inputs)
	if (locale === "ar") return ar_team_invite_title(inputs)
	if (locale === "id") return id_team_invite_title(inputs)
	if (locale === "it") return it_team_invite_title(inputs)
	if (locale === "ru") return ru_team_invite_title(inputs)
	if (locale === "pt") return pt_team_invite_title(inputs)
	return ko_team_invite_title(inputs)
});